// extracted by mini-css-extract-plugin
export default {"uppercaseText":"hdL0zt7-c0UF5A4MiM6iXw=="};